import { fromNow } from "@sorcery/utils/universal/time";

import type { DeckCommentType } from "~/types/deck";

type Props = {
  comment: DeckCommentType;
};

export const Comment = ({ comment }: Props) => {
  return (
    <div className="mb-3 flex flex-col">
      <div>
        <strong>@{comment.commenter.username}</strong>
        <span className="ml-[0.6rem] italic opacity-60">{fromNow(comment.createdAt)}</span>
      </div>
      <div className="mt-2 border-l-[3px] border-gray-500 px-3">{comment.content}</div>
    </div>
  );
};
